import { createSelector } from 'reselect'
import moment from 'moment'

export const getRecords = (state) => state.providers.records
export const getMeta = (state) => state.providers.meta
export const getProviders = createSelector(getRecords, (records) => Object.values(records))

export const getAvailableProviders = ({ location, visitType, modality } = {}) =>
  createSelector(getProviders, (records = []) =>
    records.filter((provider) => {
      if (!provider?.modalities?.includes?.(modality)) return false
      if (!provider?.schedule || !provider?.schedule.available || !provider?.schedulable) {
        return false
      }
      const visitTypeFilter = provider?.schedulable?.visitType === visitType

      if (location?.length) {
        return visitTypeFilter && provider?.schedulable?.location === location
      }
      return visitTypeFilter
    }),
  )

export const getProvider = (providerId) => createSelector(getRecords, (records = {}) => records[providerId])

export const getProviderName = (providerId) =>
  createSelector(getProvider(providerId), (provider) => provider && `${provider.firstName} ${provider.lastName}`)

export const getProviderNameAndCredentials = (providerId) =>
  createSelector(getProvider(providerId), (provider) => {
    if (!provider) return null
    let name
    if (provider.prefix) name = `${provider.prefix} `
    name += `${provider.firstName} ${provider.lastName}`
    if (provider.profile?.licenses?.length) name += `, ${provider.profile.licenses.join(', ')}`
    return name
  })

export const getProviderNameObject = (providerId) =>
  createSelector(getProvider(providerId), (provider = {}) => ({
    id: provider.providerId,
    firstName: provider.firstName,
    lastName: provider.lastName,
  }))

export const getProviderLastFetch = (providerId) => createSelector(getMeta, (meta = {}) => meta.fetches[providerId])

export const isProviderFetching = (providerId) =>
  createSelector(getMeta, (meta = {}) => meta.fetching.includes(providerId))

export const getProviderFetchError = (providerId) =>
  createSelector(getMeta, (meta = {}) => meta.fetches.errors[providerId])

export const getProviderType = (providerId) =>
  createSelector(getProvider(providerId), (provider) => {
    if (!provider) return ''
    const now = moment()
    return provider.licenses.reduce((acc, license) => {
      const expirationDate = moment(license.expDate, 'YYYY-MM-DD')
      if (expirationDate.isAfter(now)) {
        const licenseType = license.type === 'medical' ? 'Physician' : 'Therapist'
        if (!acc.includes(licenseType)) {
          if (!acc) {
            acc = licenseType
          } else {
            acc += `, ${licenseType}`
          }
        }
      }
      return acc
    }, '')
  })
